import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIScrollingColumns from 'UIComponents/layout/UIScrollingColumns';
import OverviewNavigator from './subcomponents/OverviewNavigator';
import OverviewNavigatorHeader from './subcomponents/OverviewNavigatorHeader';
import { safeSmoothScrollTo } from '../../utils/utils';
import { useEffect, useRef } from 'react'; // @ts-expect-error Could not find a declaration file for module

import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UIFlex from 'UIComponents/layout/UIFlex';
import { PANTERA } from 'HubStyleTokens/colors';
import UsageTracker from '../../utils/UsageTracker';
import { useParams } from 'react-router-dom';
import { EnabledOverviewNavigationSources, useOverviewNavigation } from '../../features/tracks';
import getLang from 'I18n/utils/getLang';
import TrackOverviewModalContainer from '../../containers/TracksPage/TrackOverviewModalContainer';
import LessonOverviewModalContainer from '../../containers/LessonsPage/LessonOverviewModalContainer';
const OverviewUIModal = styled(UIModal).withConfig({
  displayName: "OverviewModal__OverviewUIModal",
  componentId: "unk4zv-0"
})(["background-color:rgba(45,62,80,0.9) !important;div[class^='UIOverhang']{display:none;}div[role='dialog']{background:none;}div[class*='modal__container']{height:auto;}"]);
const ScrollableColumns = styled(UIScrollingColumns).withConfig({
  displayName: "OverviewModal__ScrollableColumns",
  componentId: "unk4zv-1"
})(["& > div:nth-child(1){flex:1 1 auto;padding:0;@media screen and ", "{display:none;& > div{align-items:center;background-color:red;}}}& > div:nth-child(2){flex:1 1 auto;border:none;padding:0;}"], device.laptop);
const OverviewTop = styled.div.withConfig({
  displayName: "OverviewModal__OverviewTop",
  componentId: "unk4zv-2"
})(["height:60px;@media screen and ", "{position:absolute;z-index:999;width:40px;right:0;}"], device.mobile);
const DarkCloseButton = styled(UIDialogCloseButton).withConfig({
  displayName: "OverviewModal__DarkCloseButton",
  componentId: "unk4zv-3"
})(["margin-top:2px;&::before{background:rgba(0,0,0,0.1);content:' ';border-radius:100%;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);padding:20px;z-index:-1;}&:hover::before{background:rgba(255,255,255,0.1);}&:hover{color:", ";}&::after{background:none;}"], PANTERA);
const OverviewLayoutWrapper = styled(UIFlex).withConfig({
  displayName: "OverviewModal__OverviewLayoutWrapper",
  componentId: "unk4zv-4"
})(["min-height:100%;"]);

const OverviewNavigationLayout = () => {
  const leftScrollRef = useRef(null);
  const rightScrollRef = useRef(null);
  const {
    trackId
  } = useParams();

  const onNavigatorClick = () => {
    if (rightScrollRef && rightScrollRef.current) safeSmoothScrollTo(rightScrollRef.current, 0, 0);
  };

  return /*#__PURE__*/_jsx(ScrollableColumns, {
    leftColumnContent: /*#__PURE__*/_jsx(OverviewNavigator, {
      onClick: onNavigatorClick,
      scrollRef: leftScrollRef
    }),
    leftColumnHeader: /*#__PURE__*/_jsx(OverviewNavigatorHeader, {}),
    leftScrollElementRef: leftScrollRef,
    rightColumnContent: trackId ? /*#__PURE__*/_jsx(TrackOverviewModalContainer, {}) : /*#__PURE__*/_jsx(LessonOverviewModalContainer, {}),
    rightScrollElementRef: rightScrollRef,
    style: {
      margin: 0,
      width: 'auto'
    }
  });
};

const OverviewLayout = () => {
  const {
    trackId
  } = useParams();
  return /*#__PURE__*/_jsx(OverviewLayoutWrapper, {
    align: "start",
    justify: "center",
    children: trackId ? /*#__PURE__*/_jsx(TrackOverviewModalContainer, {}) : /*#__PURE__*/_jsx(LessonOverviewModalContainer, {})
  });
};

const OverviewModal = () => {
  const isCompact = useMediaQuery(`screen and ${device.laptop}`);
  const {
    source,
    trackId,
    lessonId,
    language: languageParam
  } = useParams();
  const {
    closeOverview
  } = useOverviewNavigation();

  const handleClose = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-close',
      appearsIn: source,
      trackId,
      lessonId,
      language: languageParam || getLang()
    });
    closeOverview();
  };

  useEffect(() => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-view',
      contentId: `${trackId || lessonId}`,
      contentType: trackId ? 'TRACK' : 'LESSON',
      appearsIn: source,
      screen: isCompact ? 'compact' : 'large'
    });
  }, [lessonId, source, trackId, isCompact]);
  const showNavigation = !isCompact && !!source && EnabledOverviewNavigationSources.includes(source);
  return /*#__PURE__*/_jsxs(OverviewUIModal, {
    "data-test-id": "overview-modal",
    use: "fullscreen",
    children: [/*#__PURE__*/_jsx(OverviewTop, {
      children: /*#__PURE__*/_jsx(DarkCloseButton, {
        "data-test-id": "overview-close-button",
        onClick: handleClose
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      style: {
        padding: 0
      },
      children: showNavigation ? /*#__PURE__*/_jsx(OverviewNavigationLayout, {}) : /*#__PURE__*/_jsx(OverviewLayout, {})
    })]
  });
};

export default OverviewModal;